import React from "react";
// material-ui
import {
  Typography,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
// project imports
import MainCard from "../components/cards/MainCard";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// ==============================|| SAMPLE PAGE ||============================== //

class Terms extends React.PureComponent {
  render() {
    return (
      <MainCard title="" border={false} elevation={1} content={true} boxShadow>
        <Typography
          variant="h1"
          gutterBottom
          style={{ fontSize: "1.125rem", fontWeight: 500 }}
        >
          Terms
        </Typography>
        <Divider />
        <Typography variant="body1" paragraph></Typography>
        <Paper>
          <Typography variant="body2" gutterBottom>
            Welcome to Just Paste It! These Terms of Service govern your use of
            our website and services, so please read them carefully. By
            accessing or using Just Paste It{" "}
            {'("referred to as "the website" or "our services")'}, you agree to
            be bound by these Terms. If you do not agree with any part of these
            Terms, you may not use our website
          </Typography>
          <Typography
            variant="subtitle1"
            color="secondary"
            sx={{
              mt: 1,
            }}
          >
            Use of Our Services:
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="Just Paste It provides a platform where users can generate and share text codes. You are solely responsible for the content you paste and generate using our services" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="You must not use our services for any unlawful, harmful, or abusive purposes that violate applicable laws or regulations" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="We reserve the right to terminate or suspend your access to our services at any time without prior notice for any violation of these Terms" />
            </ListItem>
          </List>
          <Typography
            variant="subtitle1"
            color="secondary"
            sx={{
              mt: 1,
            }}
          >
            User Conduct:
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="You agree to use our services in compliance with all applicable laws and regulations" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="You must not engage in any unauthorized access to our website or attempt to disrupt our services or server" />
            </ListItem>
          </List>
          <Typography
            variant="subtitle1"
            color="secondary"
            sx={{
              mt: 1,
            }}
          >
            Acceptable Use Policy:
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, mb: 1 }}>
            The following content is strictly prohibited on our platform:
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="error" />
              </ListItemIcon>
              <ListItemText primary="Illegal content including but not limited to: drug trafficking, weapons sales, terrorism-related material, or any content that violates local, state, federal, or international laws" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="error" />
              </ListItemIcon>
              <ListItemText primary="Harmful content such as: malware, viruses, phishing attempts, spam, or any content designed to damage or gain unauthorized access to computer systems" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="error" />
              </ListItemIcon>
              <ListItemText primary="Abusive content including: harassment, bullying, threats, hate speech based on race, religion, gender, sexual orientation, disability, or other protected characteristics" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="error" />
              </ListItemIcon>
              <ListItemText primary="Inappropriate content such as: explicit sexual material, graphic violence, self-harm content, or any content harmful to minors" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="error" />
              </ListItemIcon>
              <ListItemText primary="Intellectual property violations including: copyrighted material without permission, trademark infringement, or plagiarized content" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="error" />
              </ListItemIcon>
              <ListItemText primary="Privacy violations such as: personal information of others without consent, doxxing, or any content that violates someone's privacy rights" />
            </ListItem>
          </List>
          <Typography
            variant="subtitle1"
            color="secondary"
            sx={{
              mt: 1,
            }}
          >
            Content Guidelines:
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, mb: 1 }}>
            To help you understand what is not allowed, here are specific examples of prohibited content:
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="warning" />
              </ListItemIcon>
              <ListItemText primary="Illegal Activities: Instructions for making explosives, drug recipes, hacking tutorials, counterfeit document creation guides" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="warning" />
              </ListItemIcon>
              <ListItemText primary="Malicious Code: JavaScript intended to steal cookies, executable malware files, phishing page source code, keylogger programs" />
            </ListItem>
            {/* <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="warning" />
              </ListItemIcon> */}
              {/* <ListItemText primary="Harassment: Personal attacks against individuals, revenge content, cyberbullying messages, doxxing information" /> */}
            {/* </ListItem> */}
            {/* <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="warning" />
              </ListItemIcon>
              <ListItemText primary="Inappropriate Material: Explicit sexual content, graphic violence descriptions, self-harm instructions, extremist propaganda" />
            </ListItem> */}
            {/* <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="warning" />
              </ListItemIcon>
              <ListItemText primary="Copyright Infringement: Full movie scripts, copyrighted book chapters, proprietary software code, leaked confidential documents" />
            </ListItem> */}
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="warning" />
              </ListItemIcon>
              <ListItemText primary="Spam Content: Mass marketing messages, chain letters, referral link farms, repetitive promotional content" />
            </ListItem>
          </List>
          <Typography
            variant="subtitle1"
            color="secondary"
            sx={{
              mt: 1,
            }}
          >
            Enforcement Procedures:
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, mb: 1 }}>
            Violations of our policies will result in the following consequences:
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="error" />
              </ListItemIcon>
              <ListItemText primary="First Violation: Immediate content removal and written warning sent to the user's registered email address" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="error" />
              </ListItemIcon>
              <ListItemText primary="Second Violation: Content removal and temporary account suspension for 7 days, with restricted access to all services" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="error" />
              </ListItemIcon>
              <ListItemText primary="Third Violation: Permanent account termination with immediate loss of access to all services and deletion of all associated content" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="error" />
              </ListItemIcon>
              <ListItemText primary="Severe Violations: For illegal content, threats, or malicious activities, immediate permanent ban and potential reporting to relevant authorities" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="error" />
              </ListItemIcon>
              <ListItemText primary="IP Blocking: Repeated violations may result in IP address blocking to prevent creation of new accounts" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="error" />
              </ListItemIcon>
              <ListItemText primary="Legal Action: We reserve the right to pursue legal action for violations that cause harm to our platform, users, or violate applicable laws" />
            </ListItem>
          </List>
          <Typography variant="body2" sx={{ mt: 2, mb: 1, fontStyle: 'italic' }}>
            Note: We reserve the right to take immediate action without prior warning for severe violations. Appeals can be submitted to support@justpasteit.in within 30 days of enforcement action.
          </Typography>
          <Typography
            variant="subtitle1"
            color="secondary"
            sx={{
              mt: 1,
            }}
          >
            Content Ownership and Copyright:
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="You retain ownership of the content you paste and generate using our services" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="By using our website, you grant us a non-exclusive, worldwide, royalty-free license to use, display, and distribute the content you generate for the purpose of providing our services" />
            </ListItem>
          </List>
          <Typography
            variant="subtitle1"
            color="secondary"
            sx={{
              mt: 1,
            }}
          >
            Privacy Policy:
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="Your privacy is important to us. Please review our Privacy Policy Page to understand how we collect, use, and safeguard your personal information" />
            </ListItem>
          </List>
          <Typography
            variant="subtitle1"
            color="secondary"
            sx={{
              mt: 1,
            }}
          >
            Content Expiry
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="Content generated using our services will self-destruct and expire automatically after 24 hours" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="We are not responsible for any loss of data or content after the expiration period." />
            </ListItem>
          </List>
          <Typography
            variant="subtitle1"
            color="secondary"
            sx={{
              mt: 1,
            }}
          >
            Third-Party Services
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="Our website may include links to third-party websites or services that are not under our control. We are not responsible for the content, policies, or practices of these third-party websites" />
            </ListItem>
          </List>
          <Typography
            variant="subtitle1"
            color="secondary"
            sx={{
              mt: 1,
            }}
          >
            Disclaimer of Warranties
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="Our services are provided on an as is basis without warranties of any kind, whether express or implied" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="We do not guarantee the accuracy, reliability, or availability of our services" />
            </ListItem>
          </List>
          <Typography
            variant="subtitle1"
            color="secondary"
            sx={{
              mt: 1,
            }}
          >
            Limitation of Liability:
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary=" In no event shall Just Paste It be liable for any direct, indirect, incidental, special, or consequential damages arising from the use of our website" />
            </ListItem>
          </List>
          <Typography
            variant="subtitle1"
            color="secondary"
            sx={{
              mt: 1,
            }}
          >
            Changes to the Terms:
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="We may update these Terms from time to time. Any changes will be posted on this page, and the date of the last update will be indicated at the top" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="By continuing to use our services after any changes to these Terms, you agree to be bound by the updated Terms" />
            </ListItem>
          </List>
          <div class="bg-white shadow-md rounded-lg p-6 mb-8">
            <h2 class="text-2xl font-semibold mb-4">⚠️ Terms of Sale of website (just paste it)</h2>
            <ul class="list-disc list-inside space-y-2">
              <li>
                The website is sold <strong>as-is</strong> without warranty or
                future support.
              </li>
              <li>
                <strong>Final Sale:</strong> No refunds under any circumstances
                after the payment is completed.
              </li>
              <li>
                Buyer is responsible for hosting, domain management, and any
                future maintenance.
              </li>
              <li>
                The full source code includes both frontend and backend code
                required to run the website. Everything will be provided as a ZIP.
              </li>
              <li>
                Domain transfer assistance can be provided after full payment.
              </li>
            </ul>
          </div>
          <Typography
            variant="subtitle1"
            color="secondary"
            sx={{
              mt: 1,
            }}
          >
            Contact Us
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <CheckCircleIcon color="secondary" />
              </ListItemIcon>
              <ListItemText primary="If you have any questions or concerns about these Terms, please contact us at support@justpasteit.in"></ListItemText>
            </ListItem>
          </List>

          <Typography
            variant="h1"
            gutterBottom
            sx={{
              mt: 1,
              fontSize: "10px",
            }}
          >
            By using Just Paste It, you agree to these Terms. Thank you for
            using our services!
          </Typography>
        </Paper>
      </MainCard>
    );
  }
}

export default Terms;
